(function ($) {


   // Add this after load to prevent animation
   $('.ptx-clickshield').addClass('ptx-clickshield--hasfade');


   $( ".ptx-clickshield" ).on('click',function() {
   // alert('clickd');
    $( ".ptx-site").attr("data-overlay","none");
    $('body').removeClass('noscroll');
    ptxStdLib.setNavOpen(false);
   });

   // $( ".ptx-clickshield" ).on('touchmove',function(event) {
   //    event.preventDevault();
   // });
  
})(jQuery);
   
   